import { combineReducers } from 'redux';
import loggedUser from './loggedUser';
import config from './config';

export default combineReducers({
    loggedUser,
    config
});